import { Controller } from "@hotwired/stimulus"

// Client-side-only "was this helpful?" toggle for feature pages — there's no
// backend to persist votes to, unlike support articles.
export default class extends Controller {
  static targets = ["yes", "no"]

  declare yesTarget: HTMLElement
  declare noTarget: HTMLElement

  vote(event: Event) {
    const clicked = (event.currentTarget as HTMLElement).closest(".m-vote-button")
    this.yesTarget.classList.toggle("active", clicked === this.yesTarget)
    this.noTarget.classList.toggle("active", clicked === this.noTarget)
  }
}
